export const dataHooks = {
  Label: 'form-field',
  Input: 'input-field',
};
